
import { ServiceData } from '@/types/serviceTypes';

export const landscapeDesignService: ServiceData = {
  title: 'Landscape Design',
  description: 'Comprehensive landscape planning services that transform your outdoor space into a beautiful extension of your home.',
  longDescription: [
    'Our landscape design services combine artistic vision with horticultural expertise to create outdoor spaces that reflect your personal style and complement your home\'s architecture. We believe thoughtful landscape design should balance beauty with functionality, creating spaces that are both visually stunning and practical.',
    'Our design process begins with understanding your needs, preferences, and how you plan to use your outdoor space. We consider factors like sun exposure, drainage, existing vegetation, and architectural elements to create a cohesive design that works with your property\'s natural features.',
    'Whether you\'re looking for a complete property makeover or focused enhancements to specific areas, our design team will create detailed plans that bring your vision to life. We can provide everything from conceptual designs to complete master plans with phased implementation strategies.'
  ],
  image: '/lovable-uploads/81635626-ab5c-4ce5-af4d-085dda847330.png',
  features: [
    'Custom design plans tailored to your property',
    '3D visualization of proposed landscapes',
    'Plant selection for year-round interest',
    'Sustainable, eco-friendly designs',
    'Solutions for challenging sites'
  ],
  benefits: [
    'Cohesive, professional landscape appearance',
    'Thoughtful integration of living and hardscape elements',
    'Spaces designed for your specific lifestyle needs',
    'Enhanced curb appeal and property value',
    'Reduced long-term maintenance requirements'
  ],
  process: [
    {
      title: 'Initial Consultation',
      description: 'We discuss your vision, needs, budget, and timeline while evaluating your property.'
    },
    {
      title: 'Concept Development',
      description: 'We create preliminary designs based on your input and site analysis.'
    },
    {
      title: 'Design Refinement',
      description: 'The concepts are refined with your feedback until the design perfectly matches your vision.'
    },
    {
      title: 'Implementation Planning',
      description: 'We develop detailed plans for installation, including phasing options if desired.'
    }
  ],
  relatedServices: [
    { id: 'plant-design', title: 'Plant Design' },
    { id: 'hardscape-projects', title: 'Hardscape Projects' },
    { id: 'masonry', title: 'Masonry' }
  ]
};
